import * as React from 'react'
import { useFeatureIsOn } from 'growthbook'
import { AmplitudeEvents, sendAmplitudeEvent } from '@repo/analytics/amplitude/utils'
import { usePricesForUser } from '@repo/cf-user/hooks/use-prices'

import { useHandleUpgradeOrExtension } from '../use-handle-upgrade-or-extension'
import { UPGRADE_SOURCES } from 'payments/upgrade-sources'
import { AUTO_OPEN_DELAY, LOGGED_IN_YEARLY_FEATURE_FLAG } from '../config'
import {
  getImageProps,
  getPopupTexts,
  injectBasillionFont,
  removeBasillionFont,
  shouldShowPopup,
} from '../utils'
import { Modal } from '../modal'
import { useTranslations } from '../../../contexts/header-config-context'

export function PromoPopupLoggedInYearly({
  isOpen,
  setIsOpen,
  stripeCustomerId,
}: {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  stripeCustomerId: string | null
}) {
  const t = useTranslations()
  const isFeatureOn = useFeatureIsOn(LOGGED_IN_YEARLY_FEATURE_FLAG)
  const { handleUpgradeOrExtension, error, externalUrl, success, isProcessing } =
    useHandleUpgradeOrExtension('LOGGED_IN_YEARLY', UPGRADE_SOURCES.MARKETPLACE_ACTIVE_TRIAL_POPUP)
  const { prices, currency } = usePricesForUser()
  React.useEffect(() => {
    injectBasillionFont()

    const timeout = setTimeout(() => {
      if (!isFeatureOn) {
        return
      }
      if (shouldShowPopup('LOGGED_IN_YEARLY')) {
        setIsOpen(true)
        sendAmplitudeEvent(AmplitudeEvents.PROMO_POPUP_VIEWED, {
          type: 'Logged In Yearly',
        })
      }
    }, AUTO_OPEN_DELAY)

    return () => {
      clearTimeout(timeout)
      removeBasillionFont()
    }
  }, [isFeatureOn, setIsOpen])

  if (!isFeatureOn) {
    return null
  }

  const price = `${currency.symbol}${prices.yearlyPromo}`

  const { title, description, buttonText } = getPopupTexts({
    promoPopupType: 'LOGGED_IN_YEARLY',
    price,
    t,
  })

  return (
    <Modal
      backgroundColor="bg-[#00CCCC]"
      error={error}
      success={success}
      externalUrl={externalUrl}
      title={title}
      description={description}
      buttonText={buttonText}
      imageProps={getImageProps('LOGGED_IN_YEARLY', 1)}
      promoPopupType="LOGGED_IN_YEARLY"
      onClick={() => handleUpgradeOrExtension(stripeCustomerId)}
      onClose={() => {
        sendAmplitudeEvent(AmplitudeEvents.PROMO_POPUP_CLOSED, {
          type: 'logged-in-yearly',
        })
      }}
      isProcessing={isProcessing}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  )
}
